// Sidebar navigation items are built dynamically in MainSidebar.vue
// based on user permissions. This file is kept for backward compatibility
// with the Default layout but returns an empty array.
export default function getSidebarNavItems() {
  return [];
}
